var map = {
	"./Server-Busy.None.svg": 2332,
	"./Server-Busy.OfflineDrop.svg": 2333,
	"./Server-Busy.Ssh.svg": 2334,
	"./Server-Busy.TentacleActive.svg": 2335,
	"./Server-Busy.TentaclePassive.svg": 2336,
	"./Server-CalamariNeedsUpgrade.Ssh.svg": 2337,
	"./Server-CalamariNeedsUpgrade.TentacleActive.svg": 2338,
	"./Server-CalamariNeedsUpgrade.TentaclePassive.svg": 2339,
	"./Server-Default.AzureCloudService.svg": 2340,
	"./Server-Default.AzureServiceFabricCluster.svg": 2341,
	"./Server-Default.AzureSubscription.svg": 2342,
	"./Server-Default.AzureWebApp.svg": 2343,
	"./Server-Default.Ftp.svg": 2344,
	"./Server-Default.Kubernetes.svg": 2345,
	"./Server-Default.None.svg": 2346,
	"./Server-Default.OfflineDrop.svg": 2347,
	"./Server-Default.Ssh.svg": 2348,
	"./Server-Default.TentacleActive.svg": 2349,
	"./Server-Default.TentaclePassive.svg": 2350,
	"./Server-Disabled.AzureCloudService.svg": 2351,
	"./Server-Disabled.AzureServiceFabricCluster.svg": 2352,
	"./Server-Disabled.AzureSubscription.svg": 2353,
	"./Server-Disabled.AzureWebApp.svg": 2354,
	"./Server-Disabled.Ftp.svg": 2355,
	"./Server-Disabled.Kubernetes.svg": 2356,
	"./Server-Disabled.None.svg": 2357,
	"./Server-Disabled.OfflineDrop.svg": 2358,
	"./Server-Disabled.Ssh.svg": 2359,
	"./Server-Disabled.TentacleActive.svg": 2360,
	"./Server-Disabled.TentaclePassive.svg": 2361,
	"./Server-HasWarnings.Ssh.svg": 2362,
	"./Server-HasWarnings.TentacleActive.svg": 2363,
	"./Server-HasWarnings.TentaclePassive.svg": 2364,
	"./Server-Healthy.AzureCloudService.svg": 2365,
	"./Server-Healthy.AzureServiceFabricCluster.svg": 2366,
	"./Server-Healthy.AzureSubscription.svg": 2367,
	"./Server-Healthy.AzureWebApp.svg": 2368,
	"./Server-Healthy.Ftp.svg": 2369,
	"./Server-Healthy.Kubernetes.svg": 2370,
	"./Server-Healthy.None.svg": 2371,
	"./Server-Healthy.OfflineDrop.svg": 2372,
	"./Server-Healthy.Ssh.svg": 2373,
	"./Server-Healthy.TentacleActive.svg": 2374,
	"./Server-Healthy.TentaclePassive.svg": 2375,
	"./Server-NeedsUpgrade.TentacleActive.svg": 2376,
	"./Server-NeedsUpgrade.TentaclePassive.svg": 2377,
	"./Server-Unavailable.AzureCloudService.svg": 2378,
	"./Server-Unavailable.AzureServiceFabricCluster.svg": 2379,
	"./Server-Unavailable.AzureSubscription.svg": 2380,
	"./Server-Unavailable.AzureWebApp.svg": 2381,
	"./Server-Unavailable.Ftp.svg": 2382,
	"./Server-Unavailable.Kubernetes.svg": 2383,
	"./Server-Unavailable.OfflineDrop.svg": 2384,
	"./Server-Unavailable.Ssh.svg": 2385,
	"./Server-Unavailable.TentacleActive.svg": 2386,
	"./Server-Unavailable.TentaclePassive.svg": 2387,
	"./Server-Unhealthy.AzureCloudService.svg": 2388,
	"./Server-Unhealthy.AzureServiceFabricCluster.svg": 2389,
	"./Server-Unhealthy.AzureWebApp.svg": 2390,
	"./Server-Unhealthy.Kubernetes.svg": 2391,
	"./Server-Unhealthy.OfflineDrop.svg": 2392,
	"./Server-Unhealthy.Ssh.svg": 2393,
	"./Server-Unhealthy.TentacleActive.svg": 2394,
	"./Server-Unhealthy.TentaclePassive.svg": 2395,
	"./Server-Unknown.AzureCloudService.svg": 2396,
	"./Server-Unknown.AzureServiceFabricCluster.svg": 2397,
	"./Server-Unknown.AzureSubscription.svg": 2398,
	"./Server-Unknown.AzureWebApp.svg": 2399,
	"./Server-Unknown.Ftp.svg": 2400,
	"./Server-Unknown.Kubernetes.svg": 2401,
	"./Server-Unknown.None.svg": 2402,
	"./Server-Unknown.OfflineDrop.svg": 2403,
	"./Server-Unknown.Ssh.svg": 2404,
	"./Server-Unknown.TentacleActive.svg": 2405,
	"./Server-Unknown.TentaclePassive.svg": 2406,
	"./Server-Warning.OfflineDrop.svg": 2407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2331;